var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "layout-footer" },
    [
      _c("b-container", [
        _c("ul", { staticClass: "links" }, [
          _c("li", [
            _c("img", { attrs: { src: "/img/eyes.svg", alt: "skilldoo" } })
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("© " + _vm._s(_vm.year) + " by skilldoo")]),
          _vm._v(" "),
          _vm.withLogin
            ? _c("li", [
                _c("a", { attrs: { href: "/auth/login", target: "_blank" } }, [
                  _vm._v("Login")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              { attrs: { href: "/info/datenschutz", target: "_blank" } },
              [_vm._v("Datenschutz")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "/info/agb", target: "_blank" } }, [
              _vm._v("AGBs")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "/info/nutzungsbedingungen", target: "_blank" }
              },
              [_vm._v("Nutzungsbedingungen")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "/info/impressum", target: "_blank" } }, [
              _vm._v("Impressum")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#", target: "_blank" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.showConsentPopUp.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Cookies")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "d-md-none" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openFeedback.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Feedback")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }